
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import { get } from 'lodash';
import Profile from '@/common/profile/Profile.vue';

export default Vue.extend({
    name: 'Viewer',

    components: {
        Profile
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        viewer: {
            type: Object,
            required: true
        }
    },

    computed: {
        pid():string {
            return get(this, 'viewer.pid', '');
        },
        userName():string {
            return get(this, 'viewer.participant', '');
        },
        subtitle():string {
            return get(this, 'viewer.subtitle', '');
        }
    },

    methods: {
        onViewerClick() {
            this.api.customAction({ pid: this.pid }, 'sideBarViewers');
        }
    }
});
